import MergefieldsApp from "mergefields/detail/app";
import {
  type RouteObject,
} from "react-router";

declare let viewModel: any;

export const mergefieldsRoute: RouteObject = {
  path: "mergefields",
  children: [{
    path: ":mainArea",
    loader: () => viewModel,
    Component: MergefieldsApp,
  }]
};